import { useContext, useEffect, useState } from "react"

//PrimeReact
import { Dialog } from "primereact/dialog"
import { Button } from "primereact/button"
import { InputText } from "primereact/inputtext"
import { DataTable } from "primereact/datatable"
import { Column } from "primereact/column"
import { Checkbox } from "primereact/checkbox"
import { FilterMatchMode } from "primereact/api"

//Styles
import myStyles from "../../../styles/assessments/AssessmentBlock.module.css"
import assessStyles from "../../../styles/assessments/Assessment.module.css"

// Context
import { UserContext } from "../../../context/userContext"
import { classNames } from "primereact/utils"

export default function AddAssessment({
  availableAssessments,
  onClose,
  onAdd,
  className //Optional className to allow for custom styling of the dialog, used for example to adjust width when this component is used within the ParticipantAssessmentBlockDialog
}) {
  const userCtx = useContext(UserContext)

  const [filter, setFilter] = useState("")
  const [assessments, setAssessments] = useState([])

  const enableSearch =  (availableAssessments?.length ?? 0) >= 5

  const selectEntry = (rowData) => {
    if (!rowData) return

    const index = assessments.findIndex((item) => item.id === rowData.id)
    
    if (index === -1) return
    
    let newAssessments = [...assessments]
    newAssessments[index] = { ...rowData, checked: !rowData.checked }
    setAssessments(newAssessments)
  }

  const CheckBodyTemplate = (rowData) => {
    return (
      <Checkbox
        checked={rowData.checked}
        onChange={(e) => {
          selectEntry(rowData)
        }}
      />
    )
  }

  const NameBodyTemplate = (rowData) => {
    return <span>{rowData.name}</span>
  }

  useEffect(() => {
    setAssessments(availableAssessments || [])
  }, [availableAssessments])

  return (
    <Dialog
      header={"Select assessment"}
      visible={true}
      onHide={onClose}
      className={classNames(myStyles.addAssessmentDialog, className)}
    >
      <div className={myStyles.addAssessmentDescription}>Select the assessment(s) to be completed</div>
      <div className={myStyles.addAssessmentLayout}>
        {enableSearch && <div className={myStyles.addAssessmentLayoutSearch}>
          <span
            className={`p-input-icon-right ${myStyles.addAssessmentSearch}`}
          >
            <i className="pi pi-search" />
            <InputText
              value={filter}
              onChange={(e) => {
                setFilter(e.target.value)
              }}
              placeholder="Search assessment"
              className={myStyles.addAssessmentSearch}
            />
          </span>
        </div>}
        
        <div className={myStyles.addAssessmentLayoutBody}>
          <DataTable
            className={`${assessStyles.dataTable} ${myStyles.hideTableHeader}`}
            selectionMode="single"
            onSelectionChange={(e) => {
              selectEntry(e.value)
            }}
            value={assessments}
            filters={
              filter
                ? {
                    name: {
                      value: filter,
                      matchMode: FilterMatchMode.CONTAINS,
                    },
                  }
                : {}
            }
          >
            <Column body={CheckBodyTemplate} className={myStyles.addAssessmentCheckColumn} />
            <Column body={NameBodyTemplate} />
          </DataTable>
        </div>
        <div className={myStyles.addAssessmentLayoutButton}>
          <Button
            type="button"
            label="Add"
            className={`${assessStyles.button} ${myStyles.addAssessmentButton}`}
            onClick={() => {
              const selectedAssessments = assessments?.filter(
                (assessment) => assessment.checked
              )

              if (selectedAssessments && selectedAssessments.length > 0) {
                onAdd(
                  selectedAssessments.map((assessment) => {
                    return {
                      assessment_id: assessment.id,
                      completed_assessment_id: null,
                      session_assessment: true,
                      required: false,
                      assessment_name: assessment.name,
                    }
                  })
                )
              } else {
                userCtx.setNotificationError("No assessments selected")
              }
            }}
          />
        </div>
      </div>
    </Dialog>
  )
}
